function Sequences() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Sequences</h2>
        <p class="lead">
          Sequence download by given region. Similar to Pseudogenomes App.
        </p>
      </div>
    </main>
    </>
  );
}

export default Sequences;